import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const OneDrive = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <g id="onedrive_STYLE_COLOR">
      <path
        id="onedrive_group_3_"
        fill="hsl(from hsl(206 100% 42%) h s 36%)"
        d="M9.4,8L9.4,8l4.7,2.8l2.8-1.2l0,0c0.6-0.2,1.2-0.4,1.8-0.4c0.1,0,0.2,0,0.3,0
		c-1-3.8-4.8-6-8.6-5.1C8.8,4.6,7.3,5.7,6.3,7.1c0,0,0,0,0.1,0C7.5,7.1,8.5,7.4,9.4,8z"
      />
      <path
        id="onedrive_group_2_"
        fill="hsl(from hsl(206 100% 42%) h s 42%)"
        d="M9.4,8L9.4,8c-0.9-0.5-1.9-0.8-3-0.8c0,0,0,0-0.1,0c-3.1,0-5.6,2.6-5.6,5.7c0,1.1,0.4,2.2,1,3.2
		L6,14.2l1.9-0.8l4.1-1.7l2.2-0.9L9.4,8z"
      />
      <path
        id="onedrive_group_1_"
        fill="hsl(from hsl(206 100% 42%) h s 50%)"
        d="M19,9.3c-0.1,0-0.2,0-0.3,0c-0.6,0-1.2,0.1-1.8,0.4l0,0l-2.8,1.2l0.8,0.5l2.7,1.6l1.2,0.7l4,2.4
		c1.2-2.2,0.4-5-1.9-6.2C20.3,9.5,19.7,9.3,19,9.3z"
      />
      <path
        id="onedrive_group"
        fill="hsl(from hsl(206 100% 42%) h s 59%)"
        d="M18.8,13.6l-1.2-0.7l-2.7-1.6l-0.8-0.5L12,11.7l-4.1,1.7L6,14.2L1.8,16c1.1,1.5,2.8,2.4,4.6,2.4
		h12.3c1.7,0,3.2-0.9,4-2.4L18.8,13.6z"
      />
    </g>
  </svg>
);
